var map = {
	"./Application/router.js": "808b",
	"./ApplicationDetails/router.js": "3a92",
	"./Apply/router.js": "d577",
	"./ApplyDetails/router.js": "7bba",
	"./Cooperation/router.js": "8d77",
	"./CourseDetails/router.js": "9dde",
	"./Home/router.js": "a5e8",
	"./ProjectIntroduction/router.js": "19d0",
	"./Teaching/router.js": "527c",
	"./Volunteer/router.js": "a8d4",
	"./_temp/router.js": "2513",
	"./bookStoreDetails/router.js": "5730",
	"./journalismDetails/router.js": "7a4c",
	"./journalist/router.js": "d20e",
	"./login/router.js": "29f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7994";